
import { FC, useCallback, useMemo, useRef, useState } from 'react';

import ErrorContext, { CustomError } from '@/context/ErrorContext';
import { Navigate, Outlet } from 'react-router-dom';
import ErrorPage from '@/pages/ErrorPage';
import { Box } from '@mui/material';
import IHasChildren from '@/types/IHasChildren';


interface IErrorProvider extends IHasChildren {}

const ErrorProvider: FC<IErrorProvider> = ({
    children
}) => {

    const [errors, setErrors] = useState<CustomError[]>([]);
    const timerIds = useRef<number[]>([]);

    const addError = useCallback((error: CustomError) => {
        if (error.timeout) {
            
            const timer: { id?: number } = {
                id: undefined
            }

            timer.id = window.setTimeout(() => {
                window.close(); // For now, just close the window
            }, error.timeout);

            timerIds.current.push(timer.id);
        }

        setErrors(c => {
            return [
                ...c,
                error
            ]
        })

    }, [setErrors, timerIds])

    const removeError = useCallback((error: CustomError) => {
        setErrors(c => {
            const index = c.indexOf(error);

            if (index === -1) {
                return c;
            }

            return c.filter((r, i) => i !== index);
        });
    }, [setErrors])

    const context = useMemo(() => {
        return {
            errors,
            addError,
            removeError
        }
    }, [errors, addError, removeError])

    return (
        <Box bgcolor='#F6F8FA' height='100vh'>
            <ErrorContext.Provider value={context}>
                <Outlet />
                {children}
            </ErrorContext.Provider>
        </Box>
    )
}

export default ErrorProvider